export default __webpack_public_path__ + "static/media/video.5fcdc8c9.png";